import React, { useRef } from "react";
import AddSvg from "../../assets/taiga-uikit/icons/add.svg?react";
import MinusSvg from "../../assets/taiga-uikit/icons/minus.svg?react";
import { _colorText, _style } from "../../core/core";
import { Button } from "../button/button";
import '../InputNew/InputNew.css';
import { Text } from "../texts/text";
import "./InputNewCounter.css";

type InputNewStyle = "default" | "inverse";
interface InputNewCounterProps extends React.InputHTMLAttributes<HTMLInputElement> {
    min?: number;
    max?: number;
    error?: string;
    color?: InputNewStyle;
    onChangeValue?: (value: number) => void;
}

export const InputNewCounter = React.forwardRef<HTMLInputElement, InputNewCounterProps>(
    ({ error, value, placeholder, disabled, color = "default", min = 1, max = 100, ...props }, ref) => {
        const hasValue = Boolean(value);
        const internalRef = useRef<HTMLInputElement>(null);

        // Используем переданный ref или внутренний
        const inputRef = ref || internalRef;

        const handlePrivateClick = (e: React.MouseEvent<HTMLDivElement>) => {
            // Проверяем, что клик не приходится на кнопки
            const target = e.target as HTMLElement;
            if (target.closest('button')) {
                return;
            }

            if (inputRef && typeof inputRef === 'object' && inputRef.current) {
                inputRef.current.focus();
            }
            e.preventDefault();
            e.stopPropagation();
        };
        const handleChange = (newValue: number) => {
            if (newValue < min) {
                newValue = min;
            }
            if (newValue > max) {
                newValue = max;
            }
            if (props.onChangeValue) {
                props.onChangeValue(newValue);
            }
        };

        const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
            e.preventDefault();
            e.stopPropagation();
            const text = e.clipboardData.getData('text');
            const newValue = Number(text);
            if (!isNaN(newValue)) {
                handleChange(newValue);
            }
        };


        const handlePlus = (e: React.MouseEvent<HTMLElement>) => {
            e.stopPropagation();
            e.preventDefault();
            const newValue = Number(value) + 1;
            handleChange(newValue);
        };

        const handleMinus = (e: React.MouseEvent<HTMLElement>) => {
            e.stopPropagation();
            e.preventDefault();
            const newValue = Number(value) - 1;
            handleChange(newValue);
        };

        return (
            <div onClick={handlePrivateClick} className={`input-new__wrapper${disabled ? " input-new--disabled" : ""}${error ? " input-new--error" : ""}${hasValue ? " input-new--filled" : ""}`.trim()}>
                <div className={`input-new__field input-new__field-${color}`}>
                    <Button style={_style.clear} onClick={handleMinus} icon_left={<MinusSvg />} />
                    <div className="input-new__field-group">
                        <input
                            ref={inputRef}
                            className="input-new__input input-new__counter"
                            type="number"
                            placeholder={placeholder}
                            value={value}
                            disabled={disabled}
                            onPaste={handlePaste}
                            onChange={(e) => handleChange(Number(e.target.value))}
                            {...props}
                        />
                    </div>
                    <Button style={_style.clear} onClick={handlePlus} icon_right={<AddSvg />} />

                </div>

                {error && <Text color={_colorText.negative}>{error}</Text>}
            </div>
        );
    }
);
InputNewCounter.displayName = "InputNewCounter";
